import ReactPlayer from "react-player";
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { SoundButton } from "components/player/SoundButton";
import classes from "./stripChatVideo.module.scss";
import { ReactComponent as MessageIcon } from "components/icons/message.svg";
import { ReactComponent as DefaultUserPicIcon } from "components/icons/default_userpic.svg";
import { isDisableAds } from "components/ads/utils";

interface IProps {
  username: string;
  avatarUrl: string;
  videoUrl: string;
  previewUrl: string;
}

const StripChatVideo = ({ username, avatarUrl, previewUrl, videoUrl }: IProps) => {
  const [isSound, setSound] = useState(false);
  const [isVisible, setVisible] = useState(false);

  const ref = useRef<HTMLDivElement | null>(null);

  const visibleObserver = useMemo(() => {
    return new IntersectionObserver(([entry]) => {
      setVisible(entry.isIntersecting);
    }, {
      threshold: 0.1
    });
  }, []);

  const handleToggleSound = useCallback(() => {
    setSound(!isSound);
  }, [isSound]);

  const handleClick = useCallback(() => {
    const domain = process.env.REACT_APP_STRIPCHAT_URL ?? "/";

    const params = new URLSearchParams({
      campaignId: "InFeed",
      userId: process.env.REACT_APP_STRIPCHAT_USER_ID ?? "",
      targetDomain: process.env.REACT_APP_STRIPCHAT_TARGET_DOMAIN ?? "",
      onlineModels: username
    });

    window.open(`${domain}/?${params.toString()}`, "_blank");
  }, [username]);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    visibleObserver.observe(ref.current);

    return () => {
      visibleObserver.disconnect();
    };
  }, [ref, visibleObserver]);

  return (
    <Fragment>
      {!isDisableAds() ?
        <div
          ref={ref}
          className={classes.stripChatVideo}
        >
          <div className={classes.backdropContainer}>
            <img
              className={classes.backdrop}
              src={previewUrl}
              alt=""
            />
          </div>

          { isVisible && (
            <div className={classes.playerContainer} onClick={handleClick}>
              <ReactPlayer
                url={videoUrl}
                playing
                muted={!isSound}
                allowFullScreen={false}
                playsinline
                width="100%"
                height="100%"
              />
            </div>
          )}

          <div className={classes.controls}>
            <SoundButton
              enabled={isSound}
              onClick={handleToggleSound}
            />
          </div>

          <div className={classes.modelInfo} onClick={handleClick}>
            <div className={classes.callToActions}>
              <div className={classes.callToActionsSeparator} />
              <div className={classes.callToActionsText}>
                <MessageIcon/>
                <span>Tap to chat</span>
              </div>
              <div className={classes.callToActionsSeparator} />
            </div>

            <div className={classes.model}>
              <div className={classes.modelAvatarContainer}>
                {
                  avatarUrl.length > 0
                    ? <img className={classes.modelAvatar} src={avatarUrl} alt=""/>
                    : <DefaultUserPicIcon className={classes.modelAvatar} />
                }
              </div>
              <div className={classes.modelNameContainer}>
                <div className={classes.modelName}>{username}</div>
              </div>
            </div>
          </div>
        </div>
        : null }
    </Fragment>
  );
};

export default StripChatVideo;
